import { BaseButton } from '@enter/core';
import React, { useState } from 'react';
import * as S from './confirm-dialog.styles';

interface IConfirmDialog {
    onSubmit: (initialData: any) => void;
    onCancel: () => void;

    initialData?: any;
    message?: string;
    yesMsg?: string;
    noMsg?: string;
}

export const ConfirmDialog = React.memo<IConfirmDialog>(props => {
    const { onSubmit, onCancel, initialData, message, yesMsg = 'Submit', noMsg = 'Cancel' } = props;
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        setIsLoading(true);
        try {
            await onSubmit({ initialData });
        } catch (err) {
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <S.Container>
            {message && <S.Message>{message}</S.Message>}
            <S.ButtonsContainer>
                <BaseButton type="button" onClick={onCancel} variant="outlined">
                    {noMsg}
                </BaseButton>
                <BaseButton type="button" onClick={handleSubmit} disabled={isLoading} variant="primary">
                    {yesMsg}
                </BaseButton>
            </S.ButtonsContainer>
        </S.Container>
    );
});
